var exports = {};

function noop() {}

exports = noop;
export default exports;